exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement-box[data-v-63a3b1c8]{border-radius:4px;color:#424456}.agreement-box .title[data-v-63a3b1c8]{font-size:16px;color:#212121;margin-bottom:20px;text-align:center}.agreement-box .font-small[data-v-63a3b1c8]{font-size:12px}.agreement-box .underline[data-v-63a3b1c8]{color:#000;text-decoration:underline}.agreement-box p[data-v-63a3b1c8]{text-indent:15px}.agreement-box dt[data-v-63a3b1c8]{text-indent:30px}.agreement-box dd[data-v-63a3b1c8]{text-indent:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63a3b1c8","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/agreement/service.vue
// module id = 780
// module chunks = 0